// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__4itw6","avatar":"style_avatar__2SN96","menuIcon":"style_menuIcon__2tQyt"};